/* istanbul ignore file */
/* tslint:disable */

export enum CollaboratorStatusEnum {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
}
